/**
 * Rows per page on every Quote Builder table except the product listings
 * (Phase 2 & 3 review, 2026-09-29: "groups of 50").
 */
export const PAGE_SIZE = 50;

/** Number of pages `total` rows fill; at least 1, so "page 1 of 1" holds. */
export function pageCount(total: number, perPage: number = PAGE_SIZE): number {
  return Math.max(1, Math.ceil(total / perPage));
}

/** `page` pulled back inside 1..pageCount, for a list that shrank under it. */
export function clampPage(
  page: number,
  total: number,
  perPage: number = PAGE_SIZE
): number {
  return Math.min(Math.max(1, page), pageCount(total, perPage));
}

/** The rows on one page of an array the client already holds in full. */
export function pageSlice<T>(
  rows: T[],
  page: number,
  perPage: number = PAGE_SIZE
): T[] {
  const start = (clampPage(page, rows.length, perPage) - 1) * perPage;
  return rows.slice(start, start + perPage);
}
